// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1eh6D","inputWrap":"Table_inputWrap__34Obr","col":"Table_col__1iJKL","bmiTooltip":"Table_bmiTooltip__kKAAZ"};